'use client';

import { useState, useEffect } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export default function ScrollToTop() {
  const { isDark } = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) return null;

  return (
    <button data-component-id="src/components/ScrollToTop.tsx:33:4" data-component-path="src/components/ScrollToTop.tsx" data-component-line="33" data-component-end-line="52" data-component-file="ScrollToTop.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20bottom-8%20left-8%20z-50%20p-3%20rounded-full%20shadow-lg%20transition-all%20duration-300%20hover%3Ascale-110%20hover%3Ashadow-xl%22%7D"
      onClick={scrollToTop}
      className="fixed bottom-8 left-8 z-50 p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
      style={{
        background: isDark
          ? 'linear-gradient(135deg, #F59E0B, #F97316)'
          : 'linear-gradient(135deg, #F59E0B, #F97316)',
        boxShadow: '0 4px 16px rgba(245, 158, 11, 0.35)',
      }}
      aria-label="Scroll to top"
    >
      <svg data-component-id="src/components/ScrollToTop.tsx:44:6" data-component-path="src/components/ScrollToTop.tsx" data-component-line="44" data-component-end-line="51" data-component-file="ScrollToTop.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-5%20h-5%20text-white%22%7D" className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path data-component-id="src/components/ScrollToTop.tsx:45:8" data-component-path="src/components/ScrollToTop.tsx" data-component-line="45" data-component-end-line="50" data-component-file="ScrollToTop.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </svg>
    </button>
  );
}
